module.exports = __webpack_public_path__ + "static/media/cashbackShell.75423424.png";